import angular from 'angular';

import r2a from '../../../../react/angularIntegration/r2a';
import groupsEmptyStateComponent from '../../../../react/groups/EmptyStates/GroupsEmptyStateAngular';

import groupsComponent from './groupsComponent';
import manageGroupComponent from './manageGroupComponent';

const groupsModule = angular.module('sling.dashboard.manage.groups', []);

groupsModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.manage.groups', {
    abstract: true,
    url: '/groups',
    template: '<ui-view></ui-view>',
  });

  $stateProvider.state('dashboard.manage.groups.list', {
    url: '',
    template: '<manage-groups group-type="group"></manage-groups>',
    data: {
      title: 'Groups',
    },
  });

  $stateProvider.state('dashboard.manage.groups.add', {
    url: '/add',
    controllerAs: 'ctrl',
    controller: function addGroupController() {
      this.group = {
        type: 'group',
        members: [],
      };
    },
    template: '<manage-group ng-if="ctrl.group" group="ctrl.group"></manage-group>',
  });

  $stateProvider.state('dashboard.manage.groups.edit', {
    url: '/{groupId:[0-9]+}?tab',
    controllerAs: 'ctrl',
    reloadOnSearch: false,
    resolve: {
      previousState($transition$, $state) {
        const from = $transition$.from();
        return {
          name: from.name,
          params: { ...$state.params },
        };
      },
    },
    controller: function editGroupController(
      PersonaCollection,
      Restangular,
      $stateParams,
      $state,
      previousState
    ) {
      'ngInject';

      this.initialTab = $stateParams.tab || '';
      this.previousState = previousState;
      const group = PersonaCollection.groups.find((g) => String(g.id) === $stateParams.groupId);
      if (!group) {
        $state.go('dashboard.manage.groups.list');
      } else {
        this.group = Restangular.copy(group);
      }
    },
    template: `
      <manage-group
        ng-if="ctrl.group"
        group="ctrl.group"
        previous-state="ctrl.previousState"
        tab="{{ ctrl.initialTab }}">
      </manage-group>
    `,
  });
});

groupsModule.component('manageGroups', groupsComponent);
groupsModule.component('manageGroup', manageGroupComponent);
groupsModule.component('rGroupsEmptyState', r2a(groupsEmptyStateComponent));

export default groupsModule.name;
